import React from "react";
import "../../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import download from "images/download.svg";
import { Button } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { downloadReportSingle, regenerateDownloadReport } from "../../action";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import moment from "moment";
let tableData = [
  {
    gstin: "12456789",
    tigst: 1000,
    tsgst: 1000,
    tcgst: 1000,
    inum: "123",
    ctin: "12345",
  },
];
const Table = (props) => {
  const dispatch = useDispatch();

  // const handleRegenerate = (row) => {
  //   dispatch(regenerateDownloadReport(row));
  // };

  const { downloadReportTableData } = useSelector(
    (store) => store.gstr2a2bNewRecoReducer
  );

  const handleDownload = (row) => {
    dispatch(downloadReportSingle(row));
  };
  const columns = [
    {
      dataField: "gstin",
      text: "Report Name",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "25%",
      },
      formatter: (cell, row) => <>{row.ID ? `Reco Report ${row.ID}` : "--"}</>,
    },
    {
      dataField: "fy",
      text: "Report Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "25%",
      },
      formatter: (cell, row) => <> {'Consolidated'} </>,
    },
    {
      dataField: "CREATED_DATETIME",
      text: "Generation Timestamp",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "25%",
      },
      formatter: (cell, row) => (
        <>
          {row.CREATED_DATETIME
            ? moment(row.CREATED_DATETIME).format("DD-MM-YYYY HH:mm:ss")
            : "--"}
        </>
      ),
    },

    {
      dataField: "",
      text: "Action",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "25%",
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <div
            style={{
              // display: (row.pipe_status == "COMPLETED")?"flex":"none",
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <div>
              <img
                src={download}
                alt="download"
                style={{ width: "20px", height: "22px", cursor: "pointer" }}
                onClick={() => handleDownload(row)}
              />
            </div>
            {/* <div
              style={{ marginLeft: "15px" }}
              
            >
              <Button
                onClick={() => handleRegenerate(row)}
                type="submit"
                variant="contained"
                color="primary"
                style={{
                  backgroundColor: "#4f2d7f",
                  color: "white",
                
                  height: "22px",
                  fontSize: "9px",
                  textTransform: "capitalize",
                }}
              >
                Regenerate
              </Button>
            </div> */}
          </div>
        );
      },
    },
  ];
  return (
    <>
      {downloadReportTableData?.length > 0 ? (
        <div
          className="light-border-gstr2a2bnew-table"
          style={{
            marginTop: "0.8em",
            height: "25em",
          }}
        >
          <BootstrapTable
            keyField="ID"
            data={downloadReportTableData}
            columns={columns}
            rowStyle={rowStyle2}
          />
        </div>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default Table;
